import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import { SiteMediaProvider } from "@/context/SiteMediaContext";
import { SiteContentProvider } from "@/context/SiteContentContext";
import SmoothScroll from "@/components/SmoothScroll";
import Layout from "@/components/Layout";
import AuthCallback from "@/pages/AuthCallback";

import Home from "@/pages/Home";
import Wonder from "@/pages/Wonder";
import Studio from "@/pages/Studio";
import Programs from "@/pages/Programs";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import Enroll from "@/pages/Enroll";
import Visit from "@/pages/Visit";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <ScrollTop />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/wonder" element={<Navigate to="/shop" replace />} />
          <Route path="/studio" element={<Studio />} />
          <Route path="/programs" element={<Programs />} />
          <Route path="/shop" element={<Wonder />} />
          <Route path="/shop/all" element={<Shop />} />
          <Route path="/shop/:id" element={<ProductDetail />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/enroll" element={<Enroll />} />
          <Route path="/visit" element={<Visit />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
        </Route>
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/dashboard" element={<Admin />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <div className="grain" />
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <SiteMediaProvider>
              <SiteContentProvider>
                <SmoothScroll>
                  <AppRouter />
                </SmoothScroll>
                <Toaster position="top-center" theme="light" />
              </SiteContentProvider>
            </SiteMediaProvider>
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
